import { useState } from 'react'

import { EllipsisVertical } from 'lucide-react'
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, ButtonIcon } from 'twyne-new.ui'

export default function ExtraActionsFormatter({ items }) {
  const [open, setOpen] = useState(false)

  const dropDownItemClasses = 'rounded-xs outline-hidden transition-colors twy-text-base cursor-pointer hover:twy-subtle-accent hover:twy-subtle-accent-text p-2.5 [&_a]:block [&_a]:w-full [&_button]:block [&_button]:w-full [&_button]:text-left'
  const actionSelector = 'a,button,[role="menuitem"]'

  const handleItemClick = event => {
    const clickedAction = event.target.closest(actionSelector)
    if (clickedAction) {
      setOpen(false)
      return
    }

    const action = event.currentTarget.querySelector(actionSelector)
    if (action) {
      action.click()
      setOpen(false)
    }
  }

  return <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
    <DropdownMenuTrigger>
      <ButtonIcon content='More actions'>
        <EllipsisVertical size={16} />
      </ButtonIcon>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      {items.map((item, index) => <div className={dropDownItemClasses} key={index} onClick={handleItemClick} >
        {item}
      </div>)}
    </DropdownMenuContent>
  </DropdownMenu>
}
